export enum PaymentMethod {
  credit = 'CREDIT',
  debit = 'DEBIT',
  prepaid = 'PREPAID',
  qr = 'QR'
}

const paymentMethodMap: { [key in PaymentMethod]: string } = {
  [PaymentMethod.credit]: 'crédito',
  [PaymentMethod.debit]: 'débito',
  [PaymentMethod.qr]: 'qr',
  [PaymentMethod.prepaid]: 'prepago',
}

export const paymentMethodToString = (val: PaymentMethod): string => {
  return paymentMethodMap[val];
}
